import { render, staticRenderFns } from "./Guestia.vue?vue&type=template&id=48a8f0df&"
import script from "./Guestia.vue?vue&type=script&lang=js&"
export * from "./Guestia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports